import {useContext} from "react";
import {AuthContext} from "../contexts/AuthContext";
import {AppStateContext} from "../contexts/AppStateContext";
import {useBarStreamData} from "../hooks/useBarStreamData";
import {useChartData} from "../hooks/useChartData";

// Provider reads bar data from context; stream management is handled by parent (Trade.js)
const useCandleStickChartData = (ticker, interval=5, unit='minute', barsback=200, sessionTemplate='Default') => {
  const { user } = useContext(AuthContext)
  const { settingsLoaded } = useContext(AppStateContext)
  
  const normalizedSessionTemplate = sessionTemplate || 'Default';
  
  // Read bar data from context (stream is managed centrally by Trade.js)
  const { bars, historyLoaded, loadMoreHistoricalBars, barsLoadError } = useBarStreamData(
    (settingsLoaded && ticker && interval && unit) ? ticker : null, 
    interval, 
    unit, 
    barsback,
    normalizedSessionTemplate
  );

  const isLoading = !(user?.token && settingsLoaded && historyLoaded);
  
  // Centralized transformation with proper memoization
  const chartData = useChartData(bars);
  
  return { chartData, isLoading, historyLoaded, loadMoreHistoricalBars, barsLoadError }
}

export default useCandleStickChartData;
